import { Theme, css } from '@emotion/react';

export const title = css`
  justify-content: flex-start;
`;

export const header = ({ breakpoints, spacing }: Theme) => css`
  padding: ${spacing(2)}px ${spacing(2.5)}px;

  ${breakpoints.up('sm')} {
    padding: ${spacing(3)}px ${spacing(3)}px 0;
  }
`;

export const body = ({ breakpoints, colors, spacing }: Theme) => css`
  background-color: ${colors.bgLight};
  padding: ${spacing(1.5)}px;

  ${breakpoints.up('sm')} {
    background-color: ${colors.bgDefault};
    padding: ${spacing(3)}px;
  }
`;
export const formTitle = ({ spacing }: Theme) => css`
  display: flex;
  align-items: center;
  gap: ${spacing(1)}px;
`;

export const formContainer = ({ shadow, breakpoints, colors, borderRadius, spacing }: Theme) => css`
  background-color: ${colors.bgDefault};
  border: 1px solid ${colors.borderDefault};
  border-radius: ${borderRadius[100]};
  box-shadow: ${shadow[100]};
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: ${spacing(2)}px;

  ${breakpoints.up('sm')} {
    box-shadow: none;
    padding: ${spacing(3)}px;
    margin: 0;
  }
`;
